import { lazy, Suspense } from 'react';

const LegacySatelliteReportModal = lazy(async () => {
  const module = await import('@old/features/silobags/report-satelital-modal/report-satelital-moda');

  return { default: module.ReportSatelitalModal };
});

type Props = {
  open: boolean;
  onClose: () => void;
};

export function SatelliteReportModal({ open, onClose }: Props) {
  if (!open) return null;

  return (
    <Suspense fallback={null}>
      <LegacySatelliteReportModal
        open
        setOpen={(nextOpen) => {
          if (!nextOpen) onClose();
        }}
      />
    </Suspense>
  );
}
